// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { BallPitchDataReleaseDataWire, BallPitchDataReleaseDataWireT } from '../mannequin/ball-pitch-data-release-data-wire';
import { BallPitchDataTrajectoryDataWire, BallPitchDataTrajectoryDataWireT } from '../mannequin/ball-pitch-data-trajectory-data-wire';


export class BallPitchDataWire implements flatbuffers.IUnpackableObject<BallPitchDataWireT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):BallPitchDataWire {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsBallPitchDataWire(bb:flatbuffers.ByteBuffer, obj?:BallPitchDataWire):BallPitchDataWire {
  return (obj || new BallPitchDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsBallPitchDataWire(bb:flatbuffers.ByteBuffer, obj?:BallPitchDataWire):BallPitchDataWire {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new BallPitchDataWire()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

speed():number {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

type():string|null
type(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
type(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

szTop():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

szBot():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
}

pitchType():string|null
pitchType(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
pitchType(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

releaseData(obj?:BallPitchDataReleaseDataWire):BallPitchDataReleaseDataWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? (obj || new BallPitchDataReleaseDataWire()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

trajectoryData(obj?:BallPitchDataTrajectoryDataWire):BallPitchDataTrajectoryDataWire|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? (obj || new BallPitchDataTrajectoryDataWire()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startBallPitchDataWire(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addSpeed(builder:flatbuffers.Builder, speed:number) {
  builder.addFieldFloat32(0, speed, 0.0);
}

static addType(builder:flatbuffers.Builder, typeOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, typeOffset, 0);
}

static addSzTop(builder:flatbuffers.Builder, szTop:number) {
  builder.addFieldFloat32(2, szTop, 0.0);
}

static addSzBot(builder:flatbuffers.Builder, szBot:number) {
  builder.addFieldFloat32(3, szBot, 0.0);
}

static addPitchType(builder:flatbuffers.Builder, pitchTypeOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, pitchTypeOffset, 0);
}

static addReleaseData(builder:flatbuffers.Builder, releaseDataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, releaseDataOffset, 0);
}

static addTrajectoryData(builder:flatbuffers.Builder, trajectoryDataOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, trajectoryDataOffset, 0);
}

static endBallPitchDataWire(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): BallPitchDataWireT {
  return new BallPitchDataWireT(
    this.speed(),
    this.type(),
    this.szTop(),
    this.szBot(),
    this.pitchType(),
    (this.releaseData() !== null ? this.releaseData()!.unpack() : null),
    (this.trajectoryData() !== null ? this.trajectoryData()!.unpack() : null)
  );
}


unpackTo(_o: BallPitchDataWireT): void {
  _o.speed = this.speed();
  _o.type = this.type();
  _o.szTop = this.szTop();
  _o.szBot = this.szBot();
  _o.pitchType = this.pitchType();
  _o.releaseData = (this.releaseData() !== null ? this.releaseData()!.unpack() : null);
  _o.trajectoryData = (this.trajectoryData() !== null ? this.trajectoryData()!.unpack() : null);
}
}

export class BallPitchDataWireT implements flatbuffers.IGeneratedObject {
constructor(
  public speed: number = 0.0,
  public type: string|Uint8Array|null = null,
  public szTop: number = 0.0,
  public szBot: number = 0.0,
  public pitchType: string|Uint8Array|null = null,
  public releaseData: BallPitchDataReleaseDataWireT|null = null,
  public trajectoryData: BallPitchDataTrajectoryDataWireT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const type = (this.type !== null ? builder.createString(this.type!) : 0);
  const pitchType = (this.pitchType !== null ? builder.createString(this.pitchType!) : 0);
  const releaseData = (this.releaseData !== null ? this.releaseData!.pack(builder) : 0);
  const trajectoryData = (this.trajectoryData !== null ? this.trajectoryData!.pack(builder) : 0);

  BallPitchDataWire.startBallPitchDataWire(builder);
  BallPitchDataWire.addSpeed(builder, this.speed);
  BallPitchDataWire.addType(builder, type);
  BallPitchDataWire.addSzTop(builder, this.szTop);
  BallPitchDataWire.addSzBot(builder, this.szBot);
  BallPitchDataWire.addPitchType(builder, pitchType);
  BallPitchDataWire.addReleaseData(builder, releaseData);
  BallPitchDataWire.addTrajectoryData(builder, trajectoryData);

  return BallPitchDataWire.endBallPitchDataWire(builder);
}
}
